import {
  PlotPieOptions,
  Options,
  CSSObject
} from 'highcharts';

export const highchartFontStyle: CSSObject = {
  fontFamily: 'mark',
  fontSize: '16px',
  fontWeight: '400',
  textOutline: 'none',
};

export const variablePieEvents: Highcharts.PointEventsOptionsObject = {
  select: function () {
    setSelectedState(this, true, 100);
    this.graphic?.toFront();
  },
  unselect: function () {
    setSelectedState(this, false, 300);
  },
  mouseOver: function () {
    setSelectedState(this, true, 200);
  },
  mouseOut: function () {
    const selectedPoint = this.series.points.find(p => p.selected);
    if (selectedPoint?.['id'] !== this['id']) {
      setSelectedState(this, false, 300);
    }
  }
}


const pieOptions: PlotPieOptions = {
  allowPointSelect: true,
  size: '200px',
  innerSize: '77%',
  linecap: 'butt',
  slicedOffset: 5,
  borderRadius: 0,
  states: {
    hover: {
      halo: null,
      brightness: 0,
    },
    inactive: {
      opacity: 1,
    },
  },
  dataLabels: {
    enabled: true,
    connectorColor: 'rgba(0,0,0,0.3)',
    connectorShape: 'fixedOffset',
    padding: 0,
    alignTo: 'connectors',
    style: highchartFontStyle,
  },
  tooltip: {
    followPointer: false,
    distance: 24,
  },
};

const highchartsTheme: Options = {
  chart: {
    style: highchartFontStyle,
  },
  title: null,
  tooltip: {
    enabled: true,
    backgroundColor: 'white',
    borderColor: 'none',
    hideDelay: 100,
    borderRadius: 0,
    animation: false,
    headerFormat: null,
    style: {
      ...highchartFontStyle,
    },
    shadow: false,
    followPointer: false,
  },
  legend: {
    itemStyle: highchartFontStyle,
  },
  plotOptions: {
    series: {
      // series options will also apply to charts of type column, pie, variablepie etc
      dataLabels: {
        enabled: true,
        crop: false,
        allowOverlap: true,
        padding: 0,
        verticalAlign: 'bottom',
      },
    },
    pie: pieOptions,
    variablepie: {
      ...pieOptions,
      slicedOffset: 1,
      minPointSize: 20,
      point: {
        events: variablePieEvents,
      },
    },
    column: {
      borderWidth: 0,
      borderRadius: 0,
      pointPadding: 0,
      groupPadding: 0.1,
      tooltip: {
        distance: 14,
      },
      dataLabels: {
        y: -16,
        style: {
          ...highchartFontStyle,
          fontSize: '24px',
        },
      },
    },
  },
  credits: {
    enabled: false,
  },
};

function setSelectedState(pointTarget: Highcharts.Point, selected: boolean, animationDuration?: number) {
  if (pointTarget.update != null) {
    const z = selected ? 1 : 0;
    const borderColor = selected ? 'none' : 'white';
    pointTarget.graphic.attr({
      filter: selected ?
        'drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.2))' :
        'none'
    });
    pointTarget.update(
      { z: z, borderColor: borderColor },
      true,
      { duration: animationDuration }
    );
  } else {
    console.error('Could not change selected state of selected pie slice: No update function exists.');
  }
}

export default highchartsTheme;
